"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logExecutionTime = void 0;
function logExecutionTime(logger, scope, executionTimeMs, loggerPayload) {
    logger.log({
        message: `Execution time`,
        payload: {
            ...loggerPayload,
            executionTimeMs,
            scope,
        },
    });
}
exports.logExecutionTime = logExecutionTime;
//# sourceMappingURL=logExecutionTime.js.map